import moment from "moment";
import { formatMoneyWithCurrency } from "src/utils/formatter";

export const CardHolding = ({ name, isActive, onClick, amount }) => {
  return (
    <div
      className={`tw-flex-1 tw-min-w-[250px] tw-h-[110px] tw-rounded-md tw-cursor-pointer tw-p-4 ${isActive
        ? 'tw-bg-gradient-to-b tw-from-[#0099FF] tw-to-[#1D7EE3]'
        : 'tw-bg-white'
        }`}
      onClick={onClick}
    >
      <div className="tw-flex-row">
        <div>
          <p className={`tw-font-medium tw-text-lg ${isActive ? 'tw-text-white' : 'tw-text-black'}`}>{name}</p>
        </div>
        <div className="tw-mt-4">
          <p className={`tw-text-sm tw-font-normal !tw-m-0 !tw-p-0 ${isActive ? 'tw-text-white' : 'tw-text-gray-500'} `}>Monto total {moment().year()}</p>
          <p className={`tw-text-xl tw-font-medium !tw-m-0 !tw-p-0 ${isActive ? 'tw-text-white' : 'tw-text-black'} `}>{formatMoneyWithCurrency(amount)}</p>
        </div>
      </div>
    </div>
  );
};